import React, { Component } from 'react';
import xtend from 'xtend';

import Notifications from './notifications/Notifications';
import Snackbar from './notifications/Snackbar';
import SnackBus from '../flux/SnackbarBus';
import SnackStore from '../flux/stores/SnackbarStore';
import WorkspaceHeader from './WorkspaceHeader';

import WorkspaceSideNav from './WorkspaceSideNav';
import Breadcrumbs from './Breadcrumbs';
import Overlay from './Overlay';
import MessageCenter from './header/MessageCenter';
import TicketModal from './TicketModal';
import InteractionProtection from './InteractionProtection';
import DocLink from '../../docs/DocLink';
import ErrorFallback from '../../ErrorBoundary/ErrorFallback';
import ErrorBoundary from '../../ErrorBoundary'

const steps = [
    {
      target: '.sidenav---sidenav---_2tBP',
      content: "New! tool bar menu layout, same tools but easier navigation & New support features with direct chat coming soon!",
      placement: 'auto',
      disableBeacon: false

    }
  ]

class WorkspaceWrapper extends Component {
    constructor (props) {
        super(props);

        this.state = {
            mobileNav: false,
            uploadModal: false,
            messageCenterVisible: false,
            messages: this.props.stores.messages.getState(),
            uploadProgress: false,
            overlay: false,
            ticket: false,
            socketError: false,
            run: (localStorage.getItem('tourStart') == 'disabled')?false:true,
            steps: steps,
            navExpanded: false
        };

        this.toggleResponsiveNav = this.toggleResponsiveNav.bind(this);
        this.handleSnack = this.handleSnack.bind(this);
        this.toggleMessageCenter = this.toggleMessageCenter.bind(this);
        this.onWorkspaceAction = this.onWorkspaceAction.bind(this);
        this.handleTicket = this.handleTicket.bind(this);
        this.closeTicketModal = this.closeTicketModal.bind(this);
        this.submitTicket = this.submitTicket.bind(this);
        this.handleJoyrideCallback = this.handleJoyrideCallback.bind(this);
        this.onNavToggle = this.onNavToggle.bind(this);
    }



    shouldComponentUpdate (nextProps, nextState) {
        return this.state !== nextState || nextProps.View !== this.props.View;
    }

    toggleResponsiveNav (ev) {
        ev && ev.preventDefault();
        this.setState({
            mobileNav: !this.state.mobileNav
        });
    }

    componentWillMount () {
        var self = this;
        this.props.actions.messages.get();
        this.props.stores.messages.addChangeListener(function () {
            self.setState({
                messages: self.props.stores.messages.getState()
            });
        });
    }

    componentDidMount () {
        var self = this;
        var socket = this.props.socket;

        socket.messages(function onData (data) {
            self.props.actions.messages.newMessage(data);
        });
    }

    handleSnack (snack) {
        SnackBus.emitSnack(snack);
    }

    toggleMessageCenter () {
        this.setState({
            messageCenterVisible: !this.state.messageCenterVisible
        });
    }

    onWorkspaceAction (action) {
        function toggleOverlay (hasOverlay) {
            this.setState({ overlay: hasOverlay });
        }

        var types = {
            asyncStart: toggleOverlay.bind(null, true),
            asyncEnd: toggleOverlay.bind(null, false),
            upload: function (action) {
                this.setState({
                    uploadModal: !this.state.uploadModal,
                    uploadEventID: action.eventID
                });
            }.bind(this),
            snack: this.handleSnack.bind(this, action.snack)
        };

        types[action.type](action);
    }

    handleTicket () {
        this.setState({ ticket: true });
    }

    closeTicketModal () {
        this.setState({ ticket: false });
    }

    submitTicket (data) {
        var self = this;
        var d = xtend(data, {
            userID: this.props.user.userId
        });
        this.setState({ overlay: true });

        this.props.api.accounts.ticket(d, function onResp (err, data) {
            if (err) {
                self.setState({ overlay: false });
                return self.handleSnack({
                    type: 'error',
                    message: 'Network Failure'
                });
            }

            self.handleSnack({
                type: 'success',
                message: 'Ticket Sent'
            });

            self.setState({ ticket: false, overlay: false });
        });
    }

    handleJoyrideCallback (data) {
        const { action, index, status, type } = data;

        // console.log((localStorage.getItem('tourStart') == 'disabled')?false:true);

        if (['finished', 'skipped'].includes(status)) {
          // Need to set our running state to false, and store disabled in local storage so it does not pop up again
          this.setState({ run: false });
          localStorage.setItem('tourStart', 'disabled')
        }

      };

    onNavToggle (expanded) {
        this.setState({navExpanded: expanded})
        // this.forceUpdate()
    }

    render () {
        var View = this.props.View;

        const { run, stepIndex, steps } = this.state;

        function routeToBreadcrumbs (route) {
            return [].concat(route.split('/').slice(1));
        }
        var crumbs = routeToBreadcrumbs(this.props.route.path);


        // Show breadcrumbs by default
        const hiddenBreadcrumbRoutes = ['editor', 'agenda']
        const showBreadcrubs = !hiddenBreadcrumbRoutes.some(route => {
            return this.props.route.path.indexOf(route) >= 0
        })

        var viewElmt = <View
            credentials={this.props.credentials}
            onWorkspaceAction={this.onWorkspaceAction}
            emitSnack={this.handleSnack}
        />;

        var mobileActiveClass = this.state.mobileNav ? 'mobile-active' : '';

        var bgClass = this.props.route.path.indexOf('editor') > -1 ?
            'dark' :
            null
        ;
        // var cl = this.props.background +
        var cl = bgClass +
            (mobileActiveClass ? ' ' + mobileActiveClass + '-wrapper' : '');
        // convert null string to null if the above is incorrect
        if (cl === 'null') {
            cl = null
        }

        return (
            <div id="workspace-wrapper" className={cl}>

                <InteractionProtection
                    {...this.props}
                    emitSnack={this.handleSnack}
                />

                <MessageCenter
                    {...this.state.messages}
                    actions={this.props.actions.messages}
                    toggleMessageCenter={this.toggleMessageCenter}
                    isVisible={this.state.messageCenterVisible}
                />
                <Notifications/>
                <Snackbar store={SnackStore} />
                <Overlay active={this.state.overlay} />

                {this.state.ticket ?
                    <TicketModal
                        onClose={this.closeTicketModal}
                        onSubmit={this.submitTicket}
                    /> :
                    null
                }

                {/* <WorkspaceNavigation
                    email={this.props.credentials.email}
                    toggleResponsiveNav={this.toggleResponsiveNav}
                    toggleMessageCenter={this.toggleMessageCenter}
                    credentials={this.props.credentials}
                    className={this.state.mobileNav ? 'mobile-active' : ''}
                    onTicket={this.handleTicket}
                /> */}
                <WorkspaceSideNav
                    navExpanded={this.state.navExpanded}
                    navToggle={this.onNavToggle}
                    user={this.props.credentials}
                    route={window.location.pathname}
                />

                <WorkspaceHeader
                    {...this.props}
                    navExpanded={this.state.navExpanded}
                    navToggle={this.onNavToggle}
                    emitSnack={this.handleSnack}
                    toggleResponsiveNav={this.toggleResponsiveNav}
                    toggleMessageCenter={this.toggleMessageCenter}
                    unreadMessagesCount={this.state.messages.totalUnread}
                    clientID={this.props.credentials.clientID}
                    email={this.props.credentials.email}
                    upload={this.props.actions.assetUpload}
                    uploadModal={this.state.uploadModal}
                    uploadEventID={this.state.uploadEventID}
                    onUploadModalClose={this.onWorkspaceAction.bind(this, {
                        type: 'upload'
                    })}
                    onUploadModalOpen={this.onWorkspaceAction.bind(this, {
                        type: 'upload'
                    })}
                >
                </WorkspaceHeader>

                <div id="workspace-content-wrapper">
                    <div id="workspace-content">
                        <div className="breadcrumb-container">
                            {showBreadcrubs ?
                                <Breadcrumbs breadcrumbs={crumbs} /> :
                                null
                            }
                            <div className="help-link">
                                <DocLink />
                            </div>
                        </div>
                        <ErrorBoundary FallbackComponent={ErrorFallback}>
                            {viewElmt}
                        </ErrorBoundary>
                    </div>
                </div>
                {/* <Joyride
                    run={run}
                    steps={steps}
                    callback={this.handleJoyrideCallback}
                    styles={{
                        options: {
                            arrowColor: '#fff',
                            backgroundColor: '#fff',
                            beaconSize: 36,
                            overlayColor: 'rgba(0, 0, 0, 0.5)',
                            primaryColor: '#337ab7',
                            spotlightShadow: '0 0 15px rgba(0, 0, 0, 0.5)',
                            textColor: '#333',
                            height: '150px',
                            width: undefined,
                            zIndex: 10000,
                        }
                    }}
                /> */}
            </div>
        );
    }
}

export default WorkspaceWrapper
